export default "__VITE_ASSET__B48jhRol__"